<template lang="pug">
.ge-match-wrap
    .ge-match-time(v-if="!$parent.isCurrentMatchLoaded")
    .ge-match-time(v-else-if="isHeadPreview")
        .ge-match-time-sec
            span {{ parsedTime }}
    .ge-match-time(v-else-if="$parent.matchStatus == 'playing' && match_info.period == 3 && match_info.crono == 600")
        .ge-match-time-sec
            span {{ $t('Half-time') }}
    .ge-match-time(v-else-if="$parent.matchStatus == 'playing'")
        .ge-match-time-info
            span {{$parent.getPeriodStr(match_info.period)}}
        .ge-match-time-sec
            span {{$parent.getCronoStr(match_info.crono)}}
    .ge-match-time(v-else-if="$parent.matchStatus == 'finished'")
        .ge-match-time-sec
            span {{ $t('Finished') }}
    .ge-match-time(v-else-if="$parent.matchStatus == 'upcoming'")
        .ge-match-time-sec
            span {{ parsedTime }}
    .ge-match-info-wrap

        .ge-match-info
            .ge-match-info-shield
                img(v-if="($parent.isCurrentMatchLoaded && match_info)" :src="match_info.local_negative_image", :alt="match_info.team1.team_actual_name")
            .ge-match-info__name
                span(v-if="($parent.isCurrentMatchLoaded && match_info)") {{ match_info.team1.team_actual_name }}
            .ge-match-info__score
                AnimatedValue(:value="($parent.isCurrentMatchLoaded && match_info) ? (isHeadPreview ? '-' : match_info.local_points) : ''")

        .ge-match-info
            .ge-match-info__score
                AnimatedValue(:value="($parent.isCurrentMatchLoaded && match_info) ? (isHeadPreview ? '-' : match_info.visitor_points) : ''")
            .ge-match-info__name
                span(v-if="($parent.isCurrentMatchLoaded && match_info)") {{ match_info.team2.team_actual_name }}
            .ge-match-info-shield
                img(v-if="($parent.isCurrentMatchLoaded && match_info)" :src="match_info.visitor_negative_image", :alt="match_info.team2.team_actual_name")
</template>

<script>

import AnimatedValue from "@/components/subcomponents/general/AnimatedValue.vue";

export default {
    name: "MatchInfo",
    props: {
        match_info: {}
    },
    computed: {
        parsedTime() {
            if (this.match_info.time) {
                let d = new Date((this.match_info.start_date) * 1000);
                return d.toTimeString().substr(0, 5);
            }
            return this.$i18n.t('TBD')
        },
        isHeadPreview() {
            return (this.$parent.matchStatus == 'roaster-ready' || this.$parent.matchStatus == 'upcoming')

        }
    },
    components: {
        AnimatedValue,
    }
}

</script>